jQuery.feature_import("js-information-print",
  () => import("./information-print.js"),
  mod => mod.feature_js_information_print
);